import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getStudentStatistics } from '../../../redux/api/student';
import { constants } from '../../../redux/modules/course';
import { CourseData } from '../../../types/courseData';
import CourseDetailModules from './modules/CourseDetailModules';
import CourseDetailContainer from './CourseDetail.container';
import Loading from 'components/Loading';

interface RouteParams {
  courseId: string;
  courseClassId: string;
}

const CourseDetailSwitcher: React.FC = () => {
  const { courseId, courseClassId } = useParams<RouteParams>();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [courseData, setCourseData] = useState<CourseData | null>(null);
  const [useNewDesign, setUseNewDesign] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;

    const checkDesignVersion = async () => {
      try {
        if (isMounted) {
          setLoading(true);
          setError(null);
        }

        if (!courseId || !courseClassId) {
          console.error('Parâmetros de URL inválidos');
          history.push('/courses');
          return;
        }

        if (isNaN(Number(courseId)) || isNaN(Number(courseClassId))) {
          console.error('IDs devem ser numéricos');
          history.push('/courses');
          return;
        }

        const data = await getStudentStatistics(courseId, courseClassId);

        if (!isMounted) return;

        dispatch({
          type: constants.COURSE_GET_DETAILS.SUCCESS,
          payload: data,
        });

        if (data && data.modules && data.modules.length > 0) {
          setCourseData(data);
          setUseNewDesign(true);
        } else {
          setCourseData(data);
          setUseNewDesign(false);
        }
      } catch (error) {
        console.error('Error checking course version:', error);
        if (isMounted) {
          setError('Não foi possível carregar as informações do curso. Tente novamente.');
          setUseNewDesign(false);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    checkDesignVersion();

    return () => {
      isMounted = false;
    };
  }, [courseId, courseClassId, dispatch, history]);

  if (loading) return <Loading />;

  if (error) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
        <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>Erro ao carregar curso</h2>
        <p style={{ marginBottom: '30px', fontSize: '16px', color: '#666' }}>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            backgroundColor: '#5768FF',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 500,
          }}
        >
          Tentar Novamente
        </button>
      </div>
    );
  }

  if (useNewDesign) {
    return <CourseDetailModules courseData={courseData} />;
  }

  return <CourseDetailContainer preloadedData={courseData} />;
};

export default CourseDetailSwitcher;
